import React from "react";

export default function SteelSecretary() {
  return (
    <div className="steel-page">
      <div className="steel-container">
        <div className="steel-card">
          <div className="steel-body">
            {/* Heading */}
            <div className="steel-header">
              <h2>
                AIIFA Continues State-Wise Plant Visit Initiative to Promote
                Sustainable and Technologically Advanced Steelmaking
              </h2>
              <p className="steel-date">
                14 November 2025 • Ambashakti Industries Limited
              </p>
            </div>

            {/* ================= SESSION 1 ================= */}
            <h3 className="steel-section-title">SESSION 1 (Plant Visit)</h3>

            <div className="steel-content">
              <p>
                As part of its sustained efforts to promote sustainable
                practices, enhance operational efficiency, and drive
                technological advancement across India’s steel sector, the{" "}
                <strong>
                  AIIFA Sustainable Steel Manufacturers Association{" "}
                </strong>{" "}
                has initiated a structured series of state-wise plant visits.
                These visits aim to highlight steel units that demonstrate
                leadership in innovation, environmental stewardship, and
                adherence to industry-best operational standards.
              </p>

              <p>
                Following a productive engagement at Moira Steel in Madhya
                Pradesh, the next visit in the series was conducted at
                <strong> Ambashakti Industries Limited </strong>, located in the
                UPSIDC Industrial Area, Sikandrabad, District Bulandshahr, Uttar
                Pradesh. The visit took place on{" "}
                <strong> 14 November 2025 at 12:00 PM </strong>
                and provided delegates with an opportunity to observe model
                practices in sustainable steel production, while engaging with
                the plant’s management on technological advancements and
                efficiency-focused processes.
              </p>

              <p>
                A high-level delegation led by{" "}
                <strong> Shri Yogesh Mandhani, President, AIIFA </strong>,
                attended the visit. He was accompanied by{" "}
                <strong>
                  {" "}
                  Shri Kamal Agarwal, Hon. General Secretary, AIIFA,{" "}
                </strong>{" "}
                and <strong> Shri Mohit Kapoor, Advisor, AIIFA. </strong> Their
                participation reiterated AIIFA’s commitment to strengthening
                collaboration between government institutions and India’s
                secondary steel sector.
              </p>

              <p>
                The visit also featured the presence of{" "}
                <strong> Shri Paramjeet Singh, Director, NISST </strong> , whose
                participation added considerable technical depth to the
                discussions and reinforced the ongoing efforts to modernize the
                country’s secondary steel manufacturing ecosystem.
              </p>

              <p>
                The delegation was warmly welcomed by{" "}
                <strong>
                  {" "}
                  Shri Kamal Goel, Chairman, Ambashakti Industries Limited,{" "}
                </strong>{" "}
                who presented an overview of the company’s growth trajectory,
                operational achievements, and technological capabilities. He
                highlighted that Ambashakti Industries is recognized as one of
                North India’s most advanced integrated steel manufacturing
                facilities, with an installed capacity of{" "}
                <strong>
                  {" "}
                  500,000 MTPA each for billets/ingots and TMT bars,{" "}
                </strong>
                as per CRISIL Ratings.
              </p>

              <p>
                The facility features four 40-ton induction furnaces, a modern
                <strong> Ladle Refining Furnace (LRF) </strong> for
                metallurgical precision, continuous casting machines, and a
                <strong> Tempcore-based rolling mill </strong> for the
                production of high-strength TMT rebars. Supported by advanced
                testing laboratories, automated material handling systems, and
                captive power infrastructure, the plant reflects the principles
                of sustainability, energy efficiency, and operational
                self-reliance in secondary steelmaking.
              </p>

              <p>
                The plant visit was followed by a structured technical
                interaction comprising a series of focused presentations:
              </p>

              <p>
                1. Green Steel Taxonomy — Presented by Shri Parmjeet Singh,
                Director, NISST
              </p>

              <p>
                This session provided a detailed and structured overview of the
                frameworks defining sustainable and lowcarbon steel production.
                Shri Singh explained key parameters, international benchmarks,
                and emerging compliance requirements influencing the sector’s
                transition toward environmentally responsible Manufacturing. The
                presentation equipped industry stakeholders with vital insights
                for aligning operations with evolving green norms and future
                regulatory expectations.
              </p>

              <p>
                2. Market Strategy — Presented by Shri Yogesh Mandhani,
                President, AIIFA
              </p>

              <p>
                Shri Mandhani highlighted current industry trends, shifting
                demand patterns, export prospects, and policy developments
                impacting sectoral growth. He emphasized strategic approaches
                for strengthening competitiveness within India’s secondary steel
                segment, such as technological upgrades, product
                diversification, and entry into emerging markets. His remarks
                offered valuable guidance for aligning business strategies with
                national priorities and global market trajectories.
              </p>

              <p>3. Skill and Manpower Development — Presented by NISST </p>

              <p>
                This session underscored the critical need for a technically
                skilled, future-ready workforce in the steel industry. It
                addressed prevailing skill gaps, outlined structured training
                and certification frameworks, and highlighted initiatives aimed
                at boosting productivity and operational safety. The
                presentation encouraged the adoption of continuous skill
                development programs as a foundation for technological progress
                and improved operational efficiency.
              </p>

              <p>4. Quality Standards and Mechanisms </p>

              <p>
                The concluding technical presentation covered the regulatory and
                quality frameworks governing steel production in India. It
                provided insights into BIS standards, Quality Control Orders
                (QCOs), testing protocols, and essential compliance requirements
                necessary to ensure product reliability and safety. The session
                emphasized the importance of stringent adherence to these
                standards for enhancing domestic competitiveness and meeting
                international expectations.
              </p>

              <p>
                In his{" "}
                <strong>
                  {" "}
                  concluding remarks , Shri Kamal Aggarwal, Hon. Secretary
                  General, AIIFA,{" "}
                </strong>{" "}
                commended the depth and relevance of the insights shared during
                the technical interaction. He noted that the presentation on
                Green Steel Taxonomy offered much-needed clarity on sustainable
                production frameworks, while the market strategy session
                provided a timely perspective on emerging opportunities and
                challenges facing the secondary steel sector. He further
                underscored the importance of the skill and manpower development
                session in building a future-ready workforce and highlighted the
                critical role of quality compliance in strengthening India’s
                global competitiveness.
              </p>

              <p>
                Shri Aggarwal reaffirmed <strong> AIIFA’s commitment </strong>{" "}
                to advancing industry knowledge, promoting capacity building,
                and supporting sustainable and inclusive growth across the steel
                manufacturing ecosystem.
              </p>
            </div>

            {/* ================= SESSION 2 ================= */}
            <h3 className="steel-section-title">SESSION 2 </h3>

            <div className="steel-content">
              <p>
                In continuation of this initiative, a Brainstorming Session was
                convened on 14th November 2025 (Friday) at 6:00 PM in the
                Mahogany Hall, Hotel Shangri-La Eros, New Delhi, followed by a
                networking dinner. The session witnessed the esteemed presence
                of
                <strong>
                  Joint Secretary Shri V. K. Tripathi as the Chief Guest.
                </strong>
                His visionary leadership and sustained commitment to innovation,
                investment, and sustainability have played a pivotal role in
                advancing India’s position as a global steel powerhouse.
              </p>

              <p>
                <strong> Shri Tripathi’s </strong> participation not only
                enriched the deliberations but also served as a strong source of
                encouragement for all stakeholders. His presence reaffirmed the
                Government’s continued commitment toward fostering a greener,
                more competitive, and resilient steel ecosystem for the future.
              </p>

              <p>
                <strong> Shri Yogesh Mandhani, President of AIIFA </strong>,
                opened the session with a warm welcome to the dignitaries,
                industry representatives, and stakeholders in attendance. In his
                address, he reaffirmed AIIFA’s commitment to driving sustainable
                steelmaking practices and promoting technological advancement
                across the sector. He underscored the need for collective
                industry-wide collaboration to meet emerging challenges,
                particularly those related to the green transition, regulatory
                alignment, and capacity building. Shri Mandhani noted that
                forums such as this play a crucial role in shaping
                forward-looking strategies and expressed confidence that the
                deliberations would contribute meaningfully to strengthening the
                steel industry’s pathway toward greater competitiveness,
                resilience, and environmental responsibility.
              </p>

              <p>
                The welcome address was followed by release of AIIFA STEEL
                EX-2025- Post Event Report. The detailed deliberations and
                insights shared during the conference have been comprehensively
                documented in this Post Event Report, which will serve as a
                valuable reference for shaping the sector’s future trajectory.
              </p>

              <p>
                This was followed by a notable presentation on{" "}
                <strong> “Market Overview and Future Outlook” </strong>{" "}
                delivered by{" "}
                <strong> Shri Yogesh Mandhani, President of AIIFA. </strong> In
                his address, Shri Mandhani provided a comprehensive analysis of
                the key forces shaping both the domestic and international steel
                markets. He highlighted the sustained growth in India’s steel
                demand, driven by nationwide infrastructure expansion, rapid
                urban development, and progressive industrial reforms. At the
                same time, he drew attention to challenges such as volatility in
                raw material prices, logistical bottlenecks, and the evolving
                global trade environment.
              </p>

              <p>
                Shri Mandhani emphasized the urgent need for the secondary steel
                sector to accelerate the adoption of advanced technologies,
                strengthen quality assurance mechanisms, and enhance operational
                efficiency to remain competitive in an increasingly dynamic
                market landscape. He also underscored AIIFA’s active
                participation as a member of the{" "}
                <strong>
                  {" "}
                  Iron Ore Committee constituted by the Ministry of
                  Commerce{" "}
                </strong>{" "}
                , noting the association’s strategic role in national
                discussions on raw material security, supply chain resilience,
                and critical policy interventions for sectoral growth.
              </p>

              <p>
                Looking ahead, Shri Mandhani projected an optimistic trajectory
                for the Indian steel industry, supported by robust government
                initiatives, rising domestic consumption, and the country’s
                strong commitment to green and low-carbon steel production. He
                reiterated that focused planning, efficient resource management,
                and forward-looking investments will be essential to unlocking
                emerging opportunities and elevating India’s position in the
                global steel value chain.
              </p>

              <p>
                The <strong> next presentation </strong>, focused on
                <strong>
                  {" "}
                  “Opportunities and Challenges for the Steel Sector,”{" "}
                </strong>{" "}
                was delivered by Shri Mohit Kapoor, Advisor to AIIFA. In his
                address, Shri Kapoor provided a candid assessment of the
                structural issues confronting India’s secondary steel industry,
                despite its significant contribution to national
              </p>

              <p>
                manufacturing output. He highlighted that escalating input
                costs—particularly the volatility in scrap prices and
                consistently high electricity tariffs—continue to strain the
                operational viability of induction and electric furnace units.
                He further noted that many facilities still rely on outdated
                technologies, limiting productivity, energy efficiency, and the
                ability to deliver consistent, high-quality products. Shri
                Kapoor emphasized that regulatory and environmental compliance
                requirements, though essential, often add procedural and
                financial burdens, especially for smaller enterprises. Limited
                access to affordable finance remains another critical
                constraint, curbing modernization and capacity expansion across
                the sector. Additionally, he underscored the challenge of
                inconsistent quality control practices within fragmented units,
                which contributes to product variability and affects both
                domestic market confidence and India’s global competitiveness.
              </p>

              <p>
                The subsequent presentation, delivered by{" "}
                <strong> Shri Pankaj Khetan, </strong>
                focused on the GST-related challenges affecting the secondary
                steel sector. Shri Khetan provided a detailed overview of the
                persistent difficulties encountered during the procurement of
                metal scrap, emphasizing that genuine buyers are often unfairly
                penalized for compliance lapses committed by suppliers. These
                issues, he noted, result in adverse consequences such as blocked
                input tax credit, increased working capital pressure, and
                prolonged reconciliation and verification processes. He
                highlighted the urgent need for policy rationalization and the
                establishment of robust systemic safeguards to protect bona fide
                buyers and ensure greater transparency and ease of operations
                within the GST framework.
              </p>

              <p>
                In response to the concerns presented,
                <strong> Shri Bimal Jain </strong> suggested three pragmatic
                solutions that, in his view, could effectively resolve the issue
                without causing any revenue loss to the government. His
                recommendations included: classifying all market metal scrap
                (Bazaar scrap) purchases under a separate HSN Code and bringing
                them fully under the Reverse Charge Mechanism (RCM); reducing
                the GST rate on such scrap supplies from 18% to 5% under the
                proposed new classification; and realigning enforcement
                mechanisms to ensure that accountability is placed on defaulting
                suppliers rather than compliant buyers, supported by the
                introduction of a Credit Rating System for scrap suppliers to
                enhance transparency and compliance across the value chain.
              </p>

              <p>
                The keynote address on the emerging priorities of the secondary
                steel sector was delivered by{" "}
                <strong>
                  {" "}
                  Shri V. K. Tripathi, Joint Secretary, Ministry of Steel,
                  Government of India{" "}
                </strong>
                . In his insightful remarks, Shri Tripathi highlighted the
                government’s sustained commitment to strengthening the sector
                and enabling its long-term growth. He emphasized that
                streamlined GST processes and enhanced compliance mechanisms are
                vital for improving the ease of doing business, particularly for
                small and medium steel units that constitute a significant share
                of the industry. Shri Tripathi further underscored the
                importance of robust BIS standards and their uniform
                implementation across the country to ensure consistent quality
                and reliability of steel products.
              </p>

              <p>
                Continuing his address, Shri Tripathi drew attention to the
                growing need for accelerated digitalisation and the adoption of
                advanced technologies to enhance efficiency, transparency, and
                global competitiveness within the secondary steel ecosystem. He
                also emphasized the increasing relevance of sustainability,
                highlighting effective EPR implementation, improved scrap
                management practices, and the promotion of certified green steel
                as key pillars for future-ready industry transitions.
                Reaffirming the Ministry’s commitment, he stated that the
                government remains focused on creating an enabling and
                forward-looking policy framework that supports innovation,
                sustainability, and the holistic development of the secondary
                steel sector.
              </p>

              <p>
                <strong> Green Steel Certificate Award Ceremony, </strong>
                marking a significant milestone in the industry's transition
                toward sustainable steelmaking. Shri Parmjeet Singh, Director,
                NISST, apprised the participants of the progress achieved under
                the Green Steel Certification programme and observed the growing
                willingness among secondary steel producers to adopt
                environmentally responsible manufacturing practices. He reported
                that NISST has received <strong> 90 applications </strong> for
                Green Steel Certification, signalling the sector’s increasing
                commitment to cleaner and energy-efficient production pathways.
                Of these, <strong> 32 units have been certified </strong> to
                date. Shri Singh further highlighted a noteworthy
                accomplishment—these certified units have incorporated{" "}
                <strong> up to 80% renewable energy </strong> in their
                operations, establishing an exemplary standard for the broader
                industry and underscoring the potential for wider adoption of
                green technologies across the steel value chain.
              </p>

              <p>
                The Green Steel Certificate was conferred upon the following
                companies in recognition of their exemplary commitment to
                sustainable practices and environmentally responsible steel
                production. These organisations have demonstrated notable
                progress in adopting clean technologies, enhancing resource
                efficiency, and contributing to the industry’s low-carbon
                transition:
              </p>
             

              <ol className="steel-list">
                <li>
                  <strong>SKA Steel and Power Ltd</strong>
                </li>
                <li>
                  <strong>SKA Ispat Private Limited</strong>
                </li>
                <li>
                  <strong>Jaideep Ispat and Alloys Pvt. Ltd.</strong>
                </li>
                <li>
                  <strong>MS Metals & Steel Pvt. Ltd.</strong>
                </li>
                <li>
                  <strong>Rasik Industries</strong>
                </li>
                <li>
                  <strong>Fortune Metals Limited</strong>
                </li>
                <li>
                  <strong>Kashi Vishwanath Steels Pvt. Ltd.</strong>
                </li>
                <li>
                  <strong>Radha Smelters Pvt. Ltd.</strong>
                </li>
                <li>
                  <strong>Amba Shakti Group</strong>
                </li>
              </ol>
            </div>

            {/* Footer */}
            <div className="steel-footer">
              <p>
                Thanks & Regards
                <br />
                Kamal Aggarwal
                <br />
                Hon. Sec. General
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
